import { mediaPath } from '@/mediaPath';
import styles from './Banner.module.scss';

type BannerProps = {
  banner: {
    url: string;
  };
};

const Banner = ({ data }: { data: BannerProps }) => {
  if (!data.banner) {
    return;
  }
  const background = mediaPath(data.banner.url);
  return (
    <section className={styles.bannerWrap}>
      <section
        className={styles.banner}
        style={{
          backgroundImage:
          `url(${background})`,
        }}
      />
    </section>
  );
};

export default Banner;
